import { Injectable } from '@angular/core';
import { apiResources} from "../../api/api.resources";
import {MemberServiceInterface} from "./member.service.interface";
import {MembersType, MembersTypePayload} from "../../../modules/admin/financial/entries/list/tabs/entries/dialogs/entry/types/members.type";
import {Observable} from "rxjs";
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {UserTypePayload} from "../../../modules/admin/general/users/user.type";
import {EntryTypes} from "../../../modules/admin/financial/entries/list/tabs/entries/interface/entry-types";
import {
    FilterInterface
} from "../../../modules/admin/secretary/membership/list/tabs/membership/filters/filters.interface";
import {divisionsConst} from "../../../modules/admin/ecclesiastical/divisions/constants/divisions.const";
import { MemberStatusUpdateResponse } from './member-status-response.type';

@Injectable({
  providedIn: 'root'
})
export class MemberService implements MemberServiceInterface{

  constructor(
      private _httpClient: HttpClient
  )
  {
  }


    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get membership by type
     */
    getMembers(page: number = null, filters: FilterInterface = null, term: string = null):Observable<MembersType> {
        let params = new HttpParams();


        if(term !== null)
            params = params.append('term', term);

        if(filters !== null)
        {
            params = filters.memberType.length > 0 ? params.append('memberTypes', filters.memberType.join(',')) : params;
            params = filters.ageFrom !== null ? params.append('ageFrom', filters.ageFrom) : params;
            params = filters.ageTo !== null ? params.append('ageTo', filters.ageTo) : params;
            params = filters.membersGenders.length > 0 ? params.append('membersGenders', filters.membersGenders.join(',')) : params;
            params = filters.ageGroupMembers.length > 0 ? params.append('ageGroupMembers', filters.ageGroupMembers.join(',')) : params;
        }

        if(page !== null)
            params = params.append('page', page);


        return this._httpClient.get<MembersType>(
            environment.config.apiUrl +
            apiResources.v1 +
            apiResources.secretary.base +
            apiResources.secretary.membership.base +
            apiResources.secretary.membership.base, {params: params});
    }



    /**
     * Get members by type
     */
    getMembersByFilters(page: number, filters: any [], memberType: string):Observable<MembersType> {
        let params = new HttpParams();

        params = params.append('page', page);

        return this._httpClient.get<MembersType>(
            environment.config.apiUrl +
            apiResources.v1 +
            apiResources.secretary.base +
            apiResources.secretary.membership.base +
            apiResources.secretary.membership.base, {params: params});
    }


    getMembersByBornMonth(month: string):Observable<MembersType> {
        let params = new HttpParams();

        params = params.append('date', month);

        return this._httpClient.get<MembersType>(
            environment.config.apiUrl +
            apiResources.v1 +
            apiResources.secretary.base +
            apiResources.secretary.membership.base +
            apiResources.secretary.birthdays.base +
            apiResources.secretary.birthdays.getMembersByBornMonth, {params: params});
    }


    getTithersByMonth(month: string, page: number = null):Observable<MembersType> {
        let params = new HttpParams();

        params = params.append('month', month);
        params = params.append('page', page);

        return this._httpClient.get<MembersType>(
            environment.config.apiUrl +
            apiResources.v1 +
            apiResources.secretary.base +
            apiResources.secretary.membership.base +
            apiResources.secretary.tithers.base +
            apiResources.secretary.tithers.getTithersByDate, {params: params});
    }


    getTitheHistory(memberId: number, months: number = 6): Observable<any> {
        let params = new HttpParams();

        params = params.append('memberId', memberId);
        params = params.append('months', months);

        return this._httpClient.get<any>(
            environment.config.apiUrl +
            apiResources.v1 +
            apiResources.secretary.base +
            apiResources.secretary.membership.base +
            apiResources.secretary.tithers.base +
            apiResources.secretary.tithers.getTitheHistory, {params: params});
    }




    exportBirthdaysData(month: string, type: string, selectedFields?: string[]): Observable<any> {
        let params = new HttpParams();

        params = params.append('month', month);
        params = params.append('type', type);

        if (selectedFields && selectedFields.length > 0) {
            params = params.append('fields', selectedFields.join(','));
        }

        return this._httpClient.get<MembersType>(
            environment.config.apiUrl +
            apiResources.v1 +
            apiResources.secretary.base +
            apiResources.secretary.membership.base +
            apiResources.secretary.birthdays.base +
            apiResources.secretary.birthdays.exportBirthdaysData, {params: params});
    }



    exportTithersData(month: string, type: string): Observable<any> {
        let params = new HttpParams();

        params = params.append('month', month);
        params = params.append('type', type);

        return this._httpClient.get<MembersType>(
            environment.config.apiUrl +
            apiResources.v1 +
            apiResources.secretary.base +
            apiResources.secretary.membership.base +
            apiResources.secretary.tithers.base +
            apiResources.secretary.tithers.exportTithersData, {params: params});
    }



    /**
     * Get membership by type
     */
    getMembersIndicators(): Observable<any> {

        return this._httpClient.get<any>(
            environment.config.apiUrl +
            apiResources.v1 +
            apiResources.secretary.base +
            apiResources.secretary.membership.base +
            apiResources.secretary.membership.base +
            apiResources.secretary.membership.getMembersIndicators);
    }

    // ──────────────────────────────────────────────────────────────────────
    // Variantes "Overview": usam as rotas dedicadas da Visão Geral
    // (/secretary/membership/overview/*), gated pelos CARDS (ex:
    // mem-tithers-indicators) em vez das tabs irmãs. Permitem que o Overview
    // carregue seus cards mesmo quando a tab correspondente está oculta.
    // Os métodos "tab" (getMembersIndicators/getTithersByMonth/etc) seguem
    // sendo usados pelas tabs, gated pelas suas screen_keys de tab.
    // ──────────────────────────────────────────────────────────────────────

    /**
     * Indicadores de membresia para o Card da Visão Geral.
     * Rota: /overview/members-indicators (gated por mem-members-indicators)
     */
    getMembersIndicatorsForOverview(): Observable<any> {
        return this._httpClient.get<any>(
            environment.config.apiUrl +
            apiResources.v1 +
            apiResources.secretary.base +
            apiResources.secretary.membership.base +
            apiResources.secretary.membership.overview.base +
            apiResources.secretary.membership.overview.membersIndicators);
    }

    /**
     * Dizimistas do mês para o Card da Visão Geral.
     * Rota: /overview/tithers (gated por mem-tithers-indicators)
     */
    getTithersForOverview(month: string): Observable<MembersType> {
        const params = new HttpParams().set('month', month);

        return this._httpClient.get<MembersType>(
            environment.config.apiUrl +
            apiResources.v1 +
            apiResources.secretary.base +
            apiResources.secretary.membership.base +
            apiResources.secretary.membership.overview.base +
            apiResources.secretary.membership.overview.tithers, {params});
    }

    /**
     * Aniversariantes do mês para o Card da Visão Geral.
     * Rota: /overview/birthdays (gated por mem-birthdays-indicators)
     */
    getBirthdaysForOverview(month: string): Observable<MembersType> {
        const params = new HttpParams().set('date', month);

        return this._httpClient.get<MembersType>(
            environment.config.apiUrl +
            apiResources.v1 +
            apiResources.secretary.base +
            apiResources.secretary.membership.base +
            apiResources.secretary.membership.overview.base +
            apiResources.secretary.membership.overview.birthdays, {params});
    }



    /**
     * Get membership by id
     * @param id
     */
    getMembersById(id: number): Observable<MembersType>
    {
        return this._httpClient.get<any>(
            environment.config.apiUrl +
            apiResources.v1 +
            apiResources.secretary.base +
            apiResources.secretary.membership.base +
            apiResources.secretary.membership.base + '/' + id);
    }



    /**
     * Upload avatar user image
     */
    uploadAvatarMember(file: any): Observable<any> {

        const headers = new HttpHeaders();
        headers.append('Content-Type', 'multipart/form-data');
        headers.append('Accept', 'application/json');
        let response: any;
        let path = environment.config.apiUrl +
            apiResources.v1 +
            apiResources.secretary.base +
            apiResources.secretary.membership.base +
            apiResources.secretary.membership.base +
            apiResources.secretary.membership.files.base +
            apiResources.secretary.membership.files.assets.base +
            apiResources.secretary.membership.files.assets.avatar;

        response = this._httpClient.post(path, file, {headers: headers});

        return response;
    }


    /**
     * Update status of activated from member
     */
    updateActivatedStatusMember(id: number, activated: boolean): Observable<MemberStatusUpdateResponse>
    {
        let response: Observable<MemberStatusUpdateResponse>;
        let path = environment.config.apiUrl +
            apiResources.v1 +
            apiResources.secretary.base +
            apiResources.secretary.membership.base +
            apiResources.secretary.membership.base;

        response = this._httpClient.put<MemberStatusUpdateResponse>(path + '/' + id + '/status', {activated: activated});

        return response;
    }



    /**
     * Save member
     * @param id
     * @param member
     */
    saveMember(id: number, member: MembersTypePayload) {

        const headers = new HttpHeaders();
        headers.append('Content-Type', 'multipart/form-data');
        headers.append('Accept', 'application/json');
        let body = member;
        let response: any;
        let path = environment.config.apiUrl +
            apiResources.v1 +
            apiResources.secretary.base +
            apiResources.secretary.membership.base +
            apiResources.secretary.membership.base;

        if(id !== undefined){
            response = this._httpClient.put(path + '/' + id, body);
        }else{
            response = this._httpClient.post(path, body, {headers:headers});
        }

        return response;

    }


    /**
     * Get members by group ID
     * @param groupId
     * @param page
     * @param term
     */
    getMembersByGroupId(groupId: number, page: number = null, term: string = null): Observable<any> {
        let params = new HttpParams();
        params = params.append('groupId', groupId.toString());

        if (page !== null)
            params = params.append('page', page);

        if (term !== null)
            params = params.append('term', term);

        return this._httpClient.get<any>(
            environment.config.apiUrl +
            apiResources.v1 +
            apiResources.ecclesiastical.base +
            apiResources.ecclesiastical.groups.base +
            apiResources.ecclesiastical.groups.details.base +
            apiResources.ecclesiastical.groups.details.teams.base +
            apiResources.ecclesiastical.groups.details.teams.getMembersByGroupId,
            {params: params}
        );
    }


    /**
     * Get ecclesiastical divisions and groups (Ministérios e Departamentos only)
     */
    getEcclesiasticalGroupsForMember(): Observable<any> {
        return new Observable(observer => {
            this._httpClient.get<any>(
                environment.config.apiUrl +
                apiResources.v1 +
                apiResources.ecclesiastical.base +
                apiResources.ecclesiastical.groups.base +
                apiResources.ecclesiastical.groups.getAllGroupsWithDivisions
            ).subscribe({
                next: (response: any) => {
                    // Acessa o array data da resposta
                    const divisions = response.data || [];

                    // Filtra apenas as divisões "Ministérios" e "Departamentos"
                    const filteredDivisions = divisions.filter((division: any) => {
                        // Verifica se a divisão tem grupos
                        if (division.groups && division.groups.length > 0) {
                            // Pega o slug da divisão a partir do primeiro grupo
                            const divisionSlug = division.groups[0].division[0]?.slug;
                            return divisionSlug === divisionsConst.ministries ||
                                   divisionSlug === 'departments';
                        }
                        return false;
                    });

                    observer.next(filteredDivisions);
                    observer.complete();
                },
                error: (error) => {
                    observer.error(error);
                }
            });
        });
    }

    /**
     * Save members in batch
     * @param members Array of members to save
     */
    saveMembersBatch(members: MembersTypePayload[]): Observable<any> {
        const body = { members };

        return this._httpClient.post<any>(
            environment.config.apiUrl +
            apiResources.v1 +
            apiResources.secretary.base +
            apiResources.secretary.membership.base +
            apiResources.secretary.membership.base +
            apiResources.secretary.membership.batch,
            body
        );
    }

    /**
     * Add members to a group
     * @param groupId
     * @param memberIds
     */
    addMembersToGroup(groupId: number, memberIds: number[]): Observable<any> {
        const body = {
            groupId: groupId,
            memberIds: memberIds
        };

        return this._httpClient.post<any>(
            environment.config.apiUrl +
            apiResources.v1 +
            apiResources.ecclesiastical.base +
            apiResources.ecclesiastical.groups.base +
            apiResources.ecclesiastical.groups.details.base +
            apiResources.ecclesiastical.groups.details.teams.base +
            apiResources.ecclesiastical.groups.details.teams.addMembersToGroup,
            body
        );
    }


    /**
     * Update deactivation reason for a member
     * @param id Member ID
     * @param deactivationReason Reason for deactivation (nullable)
     */
    updateDeactivationReason(id: number, deactivationReason: string | null): Observable<any> {
        const path = environment.config.apiUrl +
            apiResources.v1 +
            apiResources.secretary.base +
            apiResources.secretary.membership.base +
            apiResources.secretary.membership.base + '/' + id +
            apiResources.secretary.membership.deactivationReason;

        return this._httpClient.put(path, { deactivation_reason: deactivationReason });
    }


    /**
     * Generate membership report (PDF)
     * @param filters
     * @param term
     */
    generateReport(filters: FilterInterface, term: string = null): Observable<any> {
        const body: any = {};

        // Default status
        body.status = 'active';

        if (filters) {
            // Extract 'inactive' from memberType — it's a STATUS filter, not a member type
            let memberTypes: string[] = [];

            if (filters.memberType && filters.memberType.length > 0) {
                if (filters.memberType.includes('inactive')) {
                    body.status = 'inactive';
                }
                // Filter out 'inactive' — keep only real member types
                memberTypes = filters.memberType.filter(t => t !== 'inactive');
            }

            // Combine memberType and ageGroupMembers (both are member_type values in DB)
            if (filters.ageGroupMembers && filters.ageGroupMembers.length > 0) {
                memberTypes = [...memberTypes, ...filters.ageGroupMembers];
            }

            // Send member types as comma-separated (only if we have any)
            if (memberTypes.length > 0) {
                body.memberType = memberTypes.join(',');
            }

            // Gender filter
            if (filters.membersGenders && filters.membersGenders.length > 0) {
                body.genders = filters.membersGenders.join(',');
            }

            // Age range
            if (filters.ageFrom) {
                body.ageFrom = filters.ageFrom;
            }
            if (filters.ageTo) {
                body.ageTo = filters.ageTo;
            }
        }

        // Search term
        if (term) {
            body.search = term;
        }

        return this._httpClient.post<any>(
            environment.config.apiUrl +
            apiResources.v1 +
            apiResources.secretary.base +
            apiResources.secretary.membership.base +
            apiResources.secretary.membership.base +
            apiResources.secretary.membership.report,
            body
        );
    }

}
